export default __webpack_public_path__ + "static/media/C.668d7acf.wav";